import React from 'react';
import { observer } from 'mobx-react';
import classnames from "classnames";

import './styles.scss';

type PropsType = {
    isWide?: boolean;
    isFill?: boolean;
    isLoading?: boolean;
    style?: React.CSSProperties;
    styleInner?: React.CSSProperties;
    className?: string;
    children?: React.ReactNode;
    theme?: string;
}

export const LayoutContent = observer(({ children, style, className, theme }: PropsType) => {
    return (
        <div className={classnames('layout-content', theme ? `layout-content--${theme}` : '', className)} style={style}>
            {children}
        </div>
    );
})
